import type { ReactNode } from 'react';
import { Card } from 'react-bootstrap';
import FalconCardHeader from '@/components/common/FalconCardHeader';
import type { ChartGuideKey } from '../lib/chart-guides';
import { ChartHelpTip } from './charts/ChartHelpTip';

/** Chart/content card with title + subtitle in Falcon Card.Header. */
export function IndexerChartCard({
  title,
  subtitle,
  guideKey,
  endEl,
  children,
  className = 'overview-chart-card h-100',
  bodyClassName,
}: {
  title: ReactNode;
  subtitle?: ReactNode;
  guideKey?: ChartGuideKey;
  endEl?: ReactNode;
  children: ReactNode;
  className?: string;
  bodyClassName?: string;
}) {
  return (
    <Card className={className}>
      <FalconCardHeader
        light
        titleTag="h6"
        titleClass="mb-0"
        className="py-3 px-3"
        title={
          <span className="d-inline-flex align-items-center gap-1">
            <span>{title}</span>
            {guideKey ? <ChartHelpTip guideKey={guideKey} /> : null}
          </span>
        }
        endEl={endEl}
      >
        {subtitle != null && subtitle !== '' ? (
          <div className="text-secondary fs--1 mt-2 mb-0">{subtitle}</div>
        ) : null}
      </FalconCardHeader>
      <Card.Body className={bodyClassName}>{children}</Card.Body>
    </Card>
  );
}
